<template>
  <q-dialog
    ref="dialog"
    transition-show="fade-in"
    transition-hide="fade-out"
    @hide="onDialogHide"
  >
    <q-card
      :style="{ 'width': '700px', 'max-width': '100%' }"
    >
      <q-card-section class="row items-center q-gutter-md">
        <div
          class="row q-col-gutter-sm full-width q-pl-md q-pr-sm"
        >
          <div
            v-for="(action, index) in actions"
            :key="`action-${index}`"
            :class="`${action.class} ${action.label}`"
          >
            <q-btn
              class="full-width"
              :color="action.color"
              :text-color="$isColorDark(currentSite[`${action.color}Color`]) ? 'white' : 'black'"
              :size="action.size || 'xl'"
              :dense="action.dense"
              :disable="!action.enabled"
              @click="() => { action.handler(); onOKClick(); }"
            >
              <span
                class="row full-width items-center justify-center q-col-gutter-x-sm"
              >
                <q-icon
                  v-if="action.icon"
                  :class="`${action.iconClass} ${action.label}-${action.icon}`"
                  :name="action.icon"
                  :size="action.iconSize || 'md'"
                />
                <span>{{ action.label }}</span>
                <q-icon
                  v-if="action.iconRight"
                  :class="`${action.iconClass} ${action.label}-${action.icon}`"
                  :name="action.iconRight"
                  :size="action.iconSize || 'md'"
                />
              </span>
            </q-btn>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'OrderActionsDialog',
  configuration: ['currentSite'],
  props: {
    actions: {
      type: Array,
      default: () => ([])
    },
    onDismiss: {
      type: Function,
      default: () => {}
    }
  },
  emits: ['hide', 'ok'],
  methods: {
    show () {
      this.$refs.dialog.show()
    },
    hide () {
      this.$refs.dialog.hide()
    },
    onDialogHide () {
      this.$emit('hide')
      this.onDismiss()
    },
    onOKClick () {
      this.$emit('ok')
      this.hide()
    },
    onCancelClick () {
      this.hide()
    }
  }
}
</script>

<style lang="scss" scoped>
.recall-delivery_dining {
  position: relative;
}
.recall-delivery_dining:before {
  position: absolute;
  content: "";
  left: -14%;
  top: 32%;
  right: 0;
  border-top: 3px solid;
  border-color: inherit;

  -webkit-transform:rotate(44deg);
  -moz-transform:rotate(44deg);
  -ms-transform:rotate(44deg);
  -o-transform:rotate(44deg);
  transform:rotate(44deg);
}
.recall-delivery_dining:after {
  position: absolute;
  content: "";
  left: -10%;
  top: 28%;
  right: 0;
  border-top: 3px solid;
  border-color: var(--q-negative);

  -webkit-transform:rotate(44deg);
  -moz-transform:rotate(44deg);
  -ms-transform:rotate(44deg);
  -o-transform:rotate(44deg);
  transform:rotate(44deg);
}
</style>
